var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',_vm._b({on:{"click":_vm.navigate}},'s-button',_vm.$attrs,false),[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" "+_vm._s(_vm.$t('Invoice.makeInvoice'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }